const logWarn = (message, error) => { // eslint-disable-line
  if ((typeof window !== 'undefined' && typeof window.console !== 'undefined')) {
    if (error) {
      console.warn("Fasttrack CRM:", message, error); // eslint-disable-line
    } else {
      console.warn("Fasttrack CRM:", message); // eslint-disable-line
    }
  }
};

const log = (message, data) => { // eslint-disable-line
  if ((typeof window !== 'undefined' && typeof window.console !== 'undefined')) {
    if (data) {
      console.log("Fasttrack CRM:", message, data); // eslint-disable-line
    } else {
      console.log("Fasttrack CRM:", message); // eslint-disable-line
    }
  }
};

export { logWarn, log }; // eslint-disable-line
